import React from 'react';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';

interface EditIntegrationButtonProps {
  onClick?: (_event: React.MouseEvent<HTMLDivElement>) => void;
  onDelete?: (_event: React.MouseEvent<HTMLElement>) => void;
  integrationName?: string;
  vendorName?: string;
  environment?: string;
  userName?: string;
  password?: string;
  url?: string;
}

export const EditIntegrationButton: React.FC<EditIntegrationButtonProps> = ({
  onClick,
  onDelete,
  integrationName,
  vendorName,
  environment,
}) => {
  return (
    <div
      className="edit-integration-button flex flex-column align-items-center justify-content-center p-4 cursor-pointer relative"
      onClick={onClick}
      style={{
        border: '1px solid #ccc',
        borderRadius: '12px',
        width: '100%',
        height: '150px',
        transition: 'all 0.3s',
        position: 'relative',
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    >
      {/* Top left: vendor name and environment chip */}
      <div
        style={{
          position: 'absolute',
          top: '8px',
          left: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          maxWidth: '70%',
          zIndex: 1,
        }}
      >
        {vendorName && (
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {vendorName}
          </span>
        )}
        {environment && (
          <Tag
            value={environment}
            severity={environment === 'Production' ? 'success' : 'info'}
            style={{ fontSize: '0.7rem' }}
          />
        )}
      </div>

      {/* Trash can icon in top right corner */}
      <div
        className="delete-icon absolute"
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          cursor: 'pointer',
          color: '#ff5757',
          zIndex: 2,
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 87, 87, 0.1)')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
        onClick={(e) => {
          e.stopPropagation();
          if (onDelete) onDelete(e);
        }}
      >
        <i
          className="pi pi-trash trash-icon"
          data-pr-tooltip="Delete Integration"
          data-pr-position="left"
          data-pr-at="left-5 top"
        ></i>
        <Tooltip target=".trash-icon" />
      </div>

      <div
        className="edit-circle flex align-items-center justify-content-center mb-2"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          border: '1px solid #4F46E5',
          color: '#4F46E5',
        }}
      >
        <i className="pi pi-pencil"></i>
      </div>
      <div
        className="button-text"
        style={{
          maxWidth: '90%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        {integrationName || 'Integration'}
      </div>
    </div>
  );
};
